import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { useState } from "react";
import { Field } from "react-final-form";
import { MultipleRadioInput } from "@vk-hr-tek/ui/input";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function MultipleRadioInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else MultipleRadioInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const MultipleRadioInput_MultipleRadioInput = (t0)=>{
    const $ = c(32);
    let allFalseLabel;
    let allTrueLabel;
    let falseLabel;
    let label;
    let labelIcon;
    let name;
    let neverLabel;
    let options;
    let rest;
    let t1;
    let t2;
    let trueLabel;
    let withoutGroup;
    if ($[0] !== t0) {
        ({ disabled: t1, label, labelIcon, tooltip: t2, name, options, trueLabel, falseLabel, neverLabel, allTrueLabel, allFalseLabel, withoutGroup } = t0), rest = _object_without_properties(t0, [
            "disabled",
            "label",
            "labelIcon",
            "tooltip",
            "name",
            "options",
            "trueLabel",
            "falseLabel",
            "neverLabel",
            "allTrueLabel",
            "allFalseLabel",
            "withoutGroup"
        ]);
        $[0] = t0;
        $[1] = allFalseLabel;
        $[2] = allTrueLabel;
        $[3] = falseLabel;
        $[4] = label;
        $[5] = labelIcon;
        $[6] = name;
        $[7] = neverLabel;
        $[8] = options;
        $[9] = rest;
        $[10] = t1;
        $[11] = t2;
        $[12] = trueLabel;
        $[13] = withoutGroup;
    } else {
        allFalseLabel = $[1];
        allTrueLabel = $[2];
        falseLabel = $[3];
        label = $[4];
        labelIcon = $[5];
        name = $[6];
        neverLabel = $[7];
        options = $[8];
        rest = $[9];
        t1 = $[10];
        t2 = $[11];
        trueLabel = $[12];
        withoutGroup = $[13];
    }
    const disabled = void 0 === t1 ? false : t1;
    const tooltip = void 0 === t2 ? null : t2;
    const [byHand, setByHand] = useState(false);
    let t3;
    if ($[14] !== allFalseLabel || $[15] !== allTrueLabel || $[16] !== byHand || $[17] !== disabled || $[18] !== falseLabel || $[19] !== label || $[20] !== labelIcon || $[21] !== name || $[22] !== neverLabel || $[23] !== options || $[24] !== tooltip || $[25] !== trueLabel || $[26] !== withoutGroup) {
        t3 = (t4)=>{
            const { input } = t4;
            let groupValue = "hand";
            const values = options.map((option)=>{
                const value = input.value && input.value.find((inputValue)=>inputValue.id === option.id) || null;
                return value || {
                    id: option.id,
                    value: "always"
                };
            });
            if (values.filter(_temp).length !== options.length || byHand) if (values.filter(_temp2).length !== options.length || byHand) {
                if (values.filter(_temp3).length === options.length && !byHand) groupValue = "never";
            } else groupValue = "none";
            else groupValue = "all";
            const handleChangeForAllElements = (optionValue)=>{
                if ("all" === optionValue) {
                    input.onChange(options.map(_temp4));
                    setByHand(false);
                } else if ("none" === optionValue) {
                    input.onChange(options.map(_temp5));
                    setByHand(false);
                } else if ("never" === optionValue) {
                    input.onChange(options.map(_temp6));
                    setByHand(false);
                } else setByHand(true);
            };
            const handleChangeForElement = (id)=>(optionValue_0)=>{
                    const currentValue = values || [];
                    if ("always" === optionValue_0) {
                        input.onChange([
                            ...currentValue.filter((opt_5)=>opt_5.id !== id),
                            {
                                id,
                                value: "always"
                            }
                        ]);
                        setByHand(false);
                    } else if ("direct_only" === optionValue_0) {
                        input.onChange([
                            ...currentValue.filter((opt_6)=>opt_6.id !== id),
                            {
                                id,
                                value: "direct_only"
                            }
                        ]);
                        setByHand(false);
                    } else if ("never" === optionValue_0) {
                        input.onChange([
                            ...currentValue.filter((opt_7)=>opt_7.id !== id),
                            {
                                id,
                                value: "never"
                            }
                        ]);
                        setByHand(false);
                    }
                };
            return /*#__PURE__*/ jsx(MultipleRadioInput, _object_spread_props(_object_spread({}, input), {
                falseLabel: falseLabel,
                neverLabel: neverLabel,
                disabled: disabled,
                groupValue: groupValue,
                label: label,
                labelIcon: labelIcon,
                tooltip: tooltip,
                onChangeForAllElements: handleChangeForAllElements,
                onChangeForElement: handleChangeForElement,
                options: options,
                trueLabel: trueLabel,
                values: values,
                name: name,
                allTrueLabel: allTrueLabel,
                allFalseLabel: allFalseLabel,
                withoutGroup: withoutGroup
            }));
        };
        $[14] = allFalseLabel;
        $[15] = allTrueLabel;
        $[16] = byHand;
        $[17] = disabled;
        $[18] = falseLabel;
        $[19] = label;
        $[20] = labelIcon;
        $[21] = name;
        $[22] = neverLabel;
        $[23] = options;
        $[24] = tooltip;
        $[25] = trueLabel;
        $[26] = withoutGroup;
        $[27] = t3;
    } else t3 = $[27];
    let t4;
    if ($[28] !== name || $[29] !== rest || $[30] !== t3) {
        t4 = /*#__PURE__*/ jsx(Field, _object_spread_props(_object_spread({
            name: name
        }, rest), {
            children: t3
        }));
        $[28] = name;
        $[29] = rest;
        $[30] = t3;
        $[31] = t4;
    } else t4 = $[31];
    return t4;
};
function _temp(opt_1) {
    return "always" === opt_1.value;
}
function _temp2(opt_0) {
    return "direct_only" === opt_0.value;
}
function _temp3(opt) {
    return "never" === opt.value;
}
function _temp4(opt_2) {
    return {
        id: opt_2.id,
        value: "always"
    };
}
function _temp5(opt_3) {
    return {
        id: opt_3.id,
        value: "direct_only"
    };
}
function _temp6(opt_4) {
    return {
        id: opt_4.id,
        value: "never"
    };
}
export { MultipleRadioInput_MultipleRadioInput as MultipleRadioInput };
